import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import DashboardPage from 'internal-portal/sharedComponents/DashboardPage'
import Card from 'components/Card'
import { Box, Container } from 'components/Layout'
import { DefaultPrices } from './DefaultPrices'

export const USERS_PAGE_LENGTH = 10

const DefaultPricesList: React.VFC<RouteComponentProps> = () => (
  <DashboardPage>
    <Container>
      <Box mb="2rem">
        <Card>
          <DefaultPrices />
        </Card>
      </Box>
    </Container>
  </DashboardPage>
)

export { DefaultPricesList }
